//import libraries
import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild, ElementRef, HostListener } from '@angular/core';

//import constants
import { AppPermissions } from '../../../constants/app-permission';
import { AppFrontRoutes } from '../../../constants/app-front-routes';

//import services
import { AuthService } from '../../../services/auth.service';
import { UserLayoutService } from '../../../services/UserLayout.service';

declare var $:any;

@Component({
  selector: '[app-user-sidebar]',
  templateUrl: './user-sidebar.component.html',
  styleUrls: ['./user-sidebar.component.css']
})
export class UserSidebarComponent implements OnInit  {

  @ViewChild('navigation') navigation : ElementRef;
  
  readonly AppPermissions = AppPermissions;
  readonly AppFrontRoutes = AppFrontRoutes;
  language;
  lang;

  constructor(
    private authservice : AuthService,
    private userLayoutService: UserLayoutService
  ) { }

  ngOnInit() {

    this.userLayoutService.data.subscribe(resp => {
      if(resp)
        this.language = this.userLayoutService.langData(resp);
        this.lang = this.userLayoutService.userLang(resp);
        console.log("======== Lang =========")
        console.log(this.lang)
    });

  }


  

}
